import React from "react";
import { componentProps } from "components/baseComponent";

type Props = componentProps & {};

export class Section extends React.Component<Props> {
  render() {
    return (
      <div className=" h-full relative border-y border-[#d8d8d8] m-6">
        <div className="relative h-full max-w-7xl mx-auto border border-[#d8d8d8] p-14">
          {/* top-left */}
          <div className="absolute -top-2 -left-2 w-6 h-6 bg-whiteColor flex items-center justify-center">
            <div className="w-1 h-1 mr-2 mb-2 bg-blackColor rounded-full" />
          </div>

          {/* top-right */}
          <div className="absolute -top-2 -right-2 w-6 h-6 bg-whiteColor flex items-center justify-center">
            <div className="w-1 h-1 ml-2 mb-2 bg-blackColor rounded-full" />
          </div>

          {/* bottom-left */}
          <div className="absolute -bottom-2 -left-2 w-6 h-6 bg-whiteColor flex items-center justify-center">
            <div className="w-1 h-1 mt-2 mr-2 bg-blackColor rounded-full" />
          </div>

          {/* bottom-right */}
          <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-whiteColor flex items-center justify-center">
            <div className="w-1 h-1 ml-2 mt-2  bg-blackColor rounded-full" />
          </div>

          {/* content */}
          {this.props.children}
        </div>
      </div>
    );
  }
}
